import { useEffect, useMemo, useState } from "react";
import NewWarning from "../newWarning";
import "./style.css";
import { useSearchPagination } from "../../contexts/Ncm&Gpc_context";
import BootyPaginationSimilaridade, { BootyPaginationSimilaridade2 } from "../PaginationSimilaridade";

type TableSimilaridadeProps = {
  pages: number[];
  selected: number[];
  onToggle: (page: number) => Promise<void> | void;
  searchResultText?: string;
  code: string | number;
  hasConteudoLiquido?: boolean;
  hasMarca?: boolean;
  onRequireConfirmation?: (data: { filtros: any; raw: any }) => void;
  isDisabled: boolean;
  setIsDisabled: (disabled: boolean) => void;
};

const TableSimilaridade: React.FC<TableSimilaridadeProps> = ({
  pages,
  code,
  hasConteudoLiquido,
  hasMarca,
  onRequireConfirmation,
  isDisabled,
  setIsDisabled
}) => {
  const [view] = useState({ error: false, content: true });
  const { dataAll } = useSearchPagination();

  const {
    currentUiPage,
    setCurrentUiPage,
    rowsPerPage,
    setRowsPerPage,
    setSelectedFromRow,
    selectedDatasetPage,
  } = useSearchPagination();

  const rowCount = pages.length;

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(rowCount / rowsPerPage));
    if (currentUiPage > maxPage) setCurrentUiPage(maxPage);
  }, [rowCount, rowsPerPage, currentUiPage, setCurrentUiPage]);

  const pagedPages = useMemo(() => {
    const start = (currentUiPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return pages.slice(start, end);
  }, [pages, currentUiPage, rowsPerPage]);

  const handleChangePage = (page: number, _totalRows: number) => {
    const maxPage = Math.max(1, Math.ceil(rowCount / rowsPerPage));
    const next = Math.min(Math.max(1, page), maxPage);
    setCurrentUiPage(next);
  };

  const handleChangeRowsPerPage = (nextRowsPerPage: number, _page: number) => {
    setRowsPerPage(nextRowsPerPage);
    setCurrentUiPage(1);
  };

  const selectedCount = selectedDatasetPage ? 1 : 0;

  if (!view.content) return null;

  return (
    <div className="containerNCMPGPC" style={{ overflow: "hidden", padding: "0" }}>
      <div className="bg-color-ui-1">
        <div className="containerNCMPGPC" style={{ width: "100%" }}>
          <div className="containerNCMPGPC bg-color-white px-4 rounded-lg" style={{ width: "100%" }}>
            <NewWarning
              type="success"
              showpick={false}
              title=""
              text={`Sua pesquisa encontrou ${rowCount} 
                <span class="tooltip-up tooltip-word">
                  listas
                  <span class="tooltip-text-up">
                    Uma lista pode conter até 100 GTINs com sua Descrição do produto e Tipo de GTIN
                  </span>
                </span> 
                de GTINs. Por favor, selecione uma lista e clique no botão “Pesquisar” para visualizar o resultado.
                <br /> <br /> 
                `}
            />

            <div className="row" style={{ width: "100%", marginBottom: "40px" }}>
              <div className="containerHeaderTable">
                <div className="headerTableNCMGPC">
                  <BootyPaginationSimilaridade
                    rowsPerPage={rowsPerPage}
                    rowCount={rowCount}
                    code={code}
                    hasConteudoLiquido={hasConteudoLiquido}
                    hasMarca={hasMarca} 
                    currentPage={currentUiPage}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    onRequireConfirmation={onRequireConfirmation}
                    isDisabled={isDisabled}
                    setIsDisabled={setIsDisabled}
                  />
                </div>
              </div>

              <div className="customTableContainer">
                <div className="headerTable">
                  <div className="containerColumns">
                    <div className="columnTable">Selecionar</div>
                    <div className="columnTableLeft">Listas</div>
                  </div>
                  <div className="columnTable">Visualizado</div>
                </div>

                <div className="containetContent">
                  {pagedPages.map((page, i) => {
                    const absoluteIndex = (currentUiPage - 1) * rowsPerPage + i;
                    const alreadyVisited = dataAll?.includes(String(page));

                    return (
                      <div className="rowTableCustom" key={page}>
                        <div>
                          <input
                            className="custom-checkbox"
                            type="checkbox"
                            style={{ marginRight: "50px", marginLeft: "30px" }}
                            checked={selectedDatasetPage === page}
                            disabled={isDisabled}
                            onChange={() => {
                              if (selectedDatasetPage === page) {
                                setSelectedFromRow(0, -1);
                              } else {
                                setSelectedFromRow(page, absoluteIndex);
                              }
                            }}
                          />
                          <span style={{ color: "#008DBD", fontSize: "15px" }}>
                            Lista {page}
                          </span>
                        </div>
                        {alreadyVisited && (
                          <div className="columnTableImg tooltip-left">
                            <img width="40" height="11" src="/vbg-horizontal.png" alt="Lista já visualizada" />
                            <span className="tooltip-text-left">Lista já visualizada</span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <BootyPaginationSimilaridade2
                rowsPerPage={rowsPerPage}
                code={code}
                hasConteudoLiquido={hasConteudoLiquido}
                hasMarca={hasMarca}
                rowCount={rowCount}
                countSelected={selectedCount}
                currentPage={currentUiPage}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                onRequireConfirmation={onRequireConfirmation}
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableSimilaridade;